import React from 'react';
import { observer } from 'mobx-react';
import { PersonalInfoForm } from '../../forms/application-information-forms';
import { Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import * as styles from './application.less';

interface ICitizenshipInformationProps {
    personalInfo: PersonalInfoForm;
}

export const CitizenshipInformation: React.FC<ICitizenshipInformationProps> = observer(
    ({ personalInfo }) => {
        return (
            <React.Fragment>
                <div className={styles.sectionTitle}>Are you a US Citizen? *</div>
                <div className={styles.radioRow}>
                    <RadioGroup
                        row
                        value={personalInfo.$.IsUSCitizen.value.toString()}
                        onChange={(e, val) => personalInfo.$.IsUSCitizen.onChange(JSON.parse(val))}
                    >
                        <FormControlLabel
                            className={styles.radioLabel}
                            value="true"
                            control={<Radio className={styles.radio} />}
                            label="Yes"
                        />
                        <FormControlLabel
                            className={styles.radioLabel}
                            value="false"
                            control={<Radio className={styles.radio} />}
                            label="No"
                        />
                    </RadioGroup>
                </div>
            </React.Fragment>
        );
    }
);
